import useReservationRestClient from "@app-rest/reservations";
import { IFoodBeverage, IFoodBeverageCategory, IOfferQueryCategoryId, IOfferQueryDate, IOfferQueryPagination, IOffersQuery, IOffersQuerySystem } from "@app-rest/reservations.interfaces";
import { ref } from "vue";

const foodBeverageCategories = ref<IFoodBeverageCategory[]> ([]);
const foodBeverages = ref(new Map<number, IFoodBeverage[]>());

export function useReservationFoodBeverage() {

	const syncFoodBeverageCategories = async(query: IOffersQuery & IOfferQueryDate) => {
		const restClient = useReservationRestClient();
		const response = await restClient.foodBeverageCategories(query);
		foodBeverageCategories.value = response.data ?? [];
	}

	const syncFoodBeverage = async(query: IOffersQuerySystem & IOfferQueryDate & IOfferQueryCategoryId & Partial<IOfferQueryPagination>) => {
		const restClient = useReservationRestClient();
		const response = await restClient.foodBeverage(query);
		foodBeverages.value.set(query.categoryId, response.data ?? []);
	}

	return {
		foodBeverageCategories,
		foodBeverages,
		syncFoodBeverageCategories,
		syncFoodBeverage,
	}
}
